export const ASSEMBLY_AI_MULTILINGUAL_STREAMING_SPEECH_MODEL = "universal-streaming-multilingual";

export const ASSEMBLY_AI_LATIN_LANGUAGE_CODES = ["en", "es", "de", "fr", "pt", "it"] as const;

export const ASSEMBLY_AI_PRERECORDED_SPEECH_MODELS = ["universal-3-5-pro"] as const;

export const buildAssemblyAiPrerecordedTranscriptionConfig = () => ({
  language_detection: true,
  multichannel: true,
  speech_models: [...ASSEMBLY_AI_PRERECORDED_SPEECH_MODELS],
  language_detection_options: {
    expected_languages: [...ASSEMBLY_AI_LATIN_LANGUAGE_CODES],
    fallback_language: "auto",
  },
});
